import { render } from "./VabeneFranchiseProfile.vue?vue&type=template&id=fee84376&scoped=true&ts=true"
import script from "./VabeneFranchiseProfile.vue?vue&type=script&lang=ts"
export * from "./VabeneFranchiseProfile.vue?vue&type=script&lang=ts"

import "./VabeneFranchiseProfile.vue?vue&type=style&index=0&id=fee84376&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fee84376"]])

export default __exports__